import { Button } from 'react-bootstrap'
import textbox from './assets/textbox.png'
import './App.css'

export default function Exit({ navigate, onContact }) {
    return (
        <div className="exit-root" style={styles.main}>
            <div className="grid" style={styles.grid}>
                <div className="ammusic">
                    <h1>Thanks for stopping by!</h1>
                </div>
            </div>
            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-end' }}>
                <Button onClick={navigate} aria-label="return to welcome page"
                    style={styles.btn} onMouseOver={e => {
                        e.currentTarget.style.backgroundColor = '#f4acb7';
                    }} onMouseOut={e => {
                        e.currentTarget.style.backgroundColor = '#F6CFD6';
                    }}>
                    return to welcome page
                </Button>
                    <Button id="contact" onClick={onContact} style={{...styles.ctcBtn}}
                    onMouseOver={e => { e.currentTarget.style.backgroundColor = '#F6CFD6'; }} onMouseOut={e => {
                        e.currentTarget.style.backgroundColor = '#f2feffff'
                    }}> 
                    contact me <img src={textbox} alt="contact" style={{width: '2.25rem', marginLeft: '0.1rem'}} />
                </Button>
            </div>
        </div>

    )
}

const styles = {
    main: {
        border: '0.625rem solid #cfeaecff',
        padding: '3.125rem',
        borderRadius: '1.5625rem',
        minHeight: '100vh',
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
        justifyContent: 'center',
        boxSizing: 'border-box',
        backgroundColor: '#fff9faff',
    },
    grid: {
        display: 'flex',
        gridTemplateColumns: 'minmax(7.5rem, 18%) 1fr minmax(15rem, 30%)',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'row',
        gap: 0,
        width: '100%',
        maxWidth: '68.75rem',
    },
    btn: {
        marginTop: '1.25rem',
        fontSize: '1rem',
        fontWeight: 'bold',
        color: '#000000ff',
        backgroundColor: '#F6CFD6',
        border: 'none',
    },
    ctcBtn: {
        boxSizing: 'border-box',
        //width: '2.25rem',
        height: '2.25rem',
        backgroundColor: '#cfeaecff',
        color: '#000000ff',
        border: 'none',
        fontWeight: 'bold',
        cursor: 'pointer',
        borderRadius: '0.5rem',
        padding: '0.25rem',
        display: 'flex', 
        marginLeft: '1rem', 
        flexDirection: 'row', 
        alignItems: 'center'
    }
}